import { Link, useLocation } from 'react-router';

import { Container } from '@/components/ui/Container';
import { Icon } from '@/components/ui/Icon';
import { Signature } from '@/components/ui/Signature';
import { buttonStyles } from '@/components/ui/buttonStyles';
import { navigation, socialHref, socials } from '@/content/site';
import { cn } from '@/lib/cn';

/**
 * En-tête encre, collant (maquette). Pas de menu repliable : les trois entrées
 * tiennent jusqu'à 320 px ; sous 720 px, les réseaux disparaissent et le
 * bouton ne garde que son pictogramme.
 */
export function Header() {
  const { pathname } = useLocation();
  // Un article d'épisode appartient au blog ; la page série n'a pas d'entrée.
  const section = pathname.startsWith('/serie/') ? '/blog' : pathname;

  return (
    <header className="sticky top-0 z-20 bg-encre text-blanc">
      <Container className="flex h-(--header-height) items-center gap-3 tab:gap-12">
        <Signature animated compact />

        <nav
          aria-label="Navigation principale"
          className="flex flex-1 justify-center gap-3 text-body-xs tab:gap-5 tab:text-body-s desk:justify-start desk:gap-7.5"
        >
          {navigation.map((item) => {
            const current = section === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                aria-current={current ? 'page' : undefined}
                className={cn(
                  'inline-flex min-h-11 items-center whitespace-nowrap tab:min-h-0',
                  current
                    ? 'text-blanc underline decoration-ciel decoration-2 underline-offset-8'
                    : 'text-blanc/80 no-underline hover:text-blanc',
                )}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden gap-0.5 tab:flex">
          {socials.map((social) => (
            <a
              key={social.id}
              href={socialHref(social)}
              aria-label={social.label}
              title={social.label}
              className="flex size-10 items-center justify-center rounded-full text-blanc/80 no-underline transition-colors hover:bg-blanc/10 hover:text-blanc"
            >
              <Icon name={social.icon} />
            </a>
          ))}
        </div>

        <Link
          to="/a-propos#contact"
          aria-label="Me contacter"
          className={buttonStyles('ciel', 'px-3 py-3 tab:ml-2 tab:px-5.5 tab:py-3.5')}
        >
          <Icon name="mail" size={16} />
          <span className="hidden tab:inline">Me contacter</span>
        </Link>
      </Container>
    </header>
  );
}
